exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-footer[data-v-398e3e3a]{position:absolute;width:100%;left:0}", ""]);

// exports
